import React, { useState } from "react";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@store/store";
import { uploadFileWithFormDataThunk } from "@modules/provisional-payment/redux/thunk/application-detailThunk";
import { toast } from "react-toastify";

const ProdFileUpload = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const uploadFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setError(null);
    setSuccess(null);

    try {
      const file = event.target.files?.[0];
      if (!file) {
        setError("No file selected");
        return;
      }

      setLoading(true);
      const formData = new FormData();
      const isEsign = true; // Set this based on your requirements
      formData.append("file", file);
      formData.append("moduletype", "access");
      // formData.append("moduletype", "row");
      // formData.append("isEsign", "true");
      const response = await dispatch(
        uploadFileWithFormDataThunk({ payload: formData, 
           ...(isEsign && { isEsign }),
         }),
      ).unwrap();
      setData(response);
      setSuccess("File uploaded successfully!");
      toast.success("File uploaded successfully!");

      // Reset file input
      event.target.value = "";
    } catch (error: any) {
      console.error("Error uploading file:", error);
      toast.error(error?.message || "Failed to upload file");
      setError(error?.message || "Failed to upload file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="app-details-wrapper">
      <div className="page-content mt-4">
        <h1 className="pb-4">File Upload</h1>
        <input
          type="file"
          onChange={(e) => uploadFileChange(e)}
          disabled={loading}
        />
        {loading && <p style={{ color: "blue" }}>Uploading...</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {data && (
          <div>
            <p>File Name: {data?.fileName}</p>
            <p>File Size: {data?.fileSize}</p>
            <p>File Type: {data.fileType}</p>
            <p>File URL: {data.fileUrl}</p>
            <img
              src={data.fileUrl}
              alt="Uploaded File"
              style={{ maxWidth: "200px", marginTop: "10px" }}
            />
          </div>
        )}
      </div>
    </Box>
  );
};

export default ProdFileUpload;
